import * as React from 'react';
import { ILxsAnchorContainerData } from './lxs-anchor-container.data';
import { ILxsAnchorContainerProps } from './lxs-anchor-container.props.autogenerated';

export interface ILxsAnchorContainerViewProps extends ILxsAnchorContainerProps<ILxsAnchorContainerData> {}

class LxsAnchorContainer extends React.PureComponent<ILxsAnchorContainerProps<ILxsAnchorContainerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props) as JSX.Element | null;
    }
}

export default LxsAnchorContainer;
